<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Voucher. Service and License</h5>
      <b-row>
        <b-col md="9">
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <div class="p-3">
              <b-row>
                <b-col md="6">
                <b-form-group
                  id="fieldset-1"
                  label="Search"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                  <input
                    placeholder="Search"
                    v-model="title"
                    name="search"
                    type="text"
                    data-vv-as="Search"
                    class="form-control"
                  />
                </b-form-group>
                </b-col>
                <b-col md="6">
                <b-form-group
                  id="fieldset-1"
                  label="Voucer Service Licence Type"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                  <b-form-select
                    v-model="vsl_type"
                    name="vsl_type"
                    data-vv-as="Voucer Service Licence Type"
                    class="mb-3"
                  >
                    <template v-slot:first>
                      <option value disabled>-- Voucer Service Licence Type --</option>
                    </template>
                    <option value="pa_service_cs_hotline">PA Service + CS Hotline</option>
                    <option value="refinancing">Refinancing</option>
                    <option value="insurance">Insurance</option>
                    <option value="content_photo">Content Creation - Photo</option>
                    <option value="content_video">Content Creation - Video</option>
                    <option value="influencer">Influencer</option>
                    <option value="dedicated_hero">Dedicated HERO</option>
                    <option value="stockpoint">Paxel Market + stockpoint</option>
                    <option value="izin_bpom">BPOM/UKM License</option>
                  </b-form-select>
                </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                <b-form-group
                  id="fieldset-1"
                  label="Join Period"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                  <b-row>
                  <b-col>
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 form-control form-control-sm img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class="mt-n1" />
                      </b-col>
                      <b-col md="6" class="px-0">
                        <datepicker
                          input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="created_at_start"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="px-4 form-control form-control-sm del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left">
                            <b-col>
                              <b-button
                                class="m-0 p-0 mt-n1 bg-transparent border-0"
                                @click="resetDateCreatedStart"
                                variant="outline-light"
                              >
                                <i class="text-danger fas fa-times"></i>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 form-control form-control-sm img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class="mt-n1" />
                      </b-col>
                      <b-col md="6" class="px-0">
                        <datepicker
                          input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="created_at_end"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="px-4 form-control form-control-sm del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left">
                            <b-col>
                              <b-button
                                class="m-0 p-0 mt-n1 bg-transparent border-0"
                                @click="resetDateCreatedEnd"
                                variant="outline-light"
                              >
                                <i class="text-danger fas fa-times"></i>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                </b-form-group>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col md="12">
                <b-form-group
                  id="fieldset-1"
                  label="Valid To Period"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                <b-row>
                  <b-col>
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 form-control form-control-sm img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class="mt-n1" />
                      </b-col>
                      <b-col md="6" class="px-0">
                        <datepicker
                          input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="valid_until_start"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="px-4 form-control form-control-sm del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left">
                            <b-col>
                              <b-button
                                class="m-0 p-0 mt-n1 bg-transparent border-0"
                                @click="resetDateValidStart"
                                variant="outline-light"
                              >
                                <i class="text-danger fas fa-times"></i>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 form-control form-control-sm img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class="mt-n1" />
                      </b-col>
                      <b-col md="6" class="px-0">
                        <datepicker
                          input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                          placeholder="Select Date"
                          v-model="valid_until_end"
                          :format="customFormatter"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </b-col>
                      <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="px-4 form-control form-control-sm del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left">
                            <b-col>
                              <b-button
                                class="m-0 p-0 mt-n1 bg-transparent border-0"
                                @click="resetDateValidEnd"
                                variant="outline-light"
                              >
                                <i class="text-danger fas fa-times"></i>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                </b-form-group>
                </b-col>
              </b-row>
              <br>
                <b-row style="text-align-last: right;">
                  <b-col>
                    <b-button variant="outline-secondary" @click="resetSearch()" class="mr-3">Set Ulang</b-button>
                    <b-button variant="primary" @click="search()">Cari</b-button>
                  </b-col>
                </b-row>
              </div>
              <b-dropdown-item class="pointer-off" style="width:450px;"></b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <!-- <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group> -->
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
                <!-- <b-button class="btn btn-warning px-4" style="padding-top:6px;padding-bottom:6px" :disabled="loadingCSV" @click="downloadCSV()">
                  <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner> <i class="fas fa-file-download" style="font-size:16px"></i> &nbsp; Export to CSV
                </b-button> -->
                <router-link :to="{name: 'createVoucerService'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
           <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        hover
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        stacked="md"
        :busy="loading"
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
              :value="data"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(selected)="{ rowSelected, item, index }">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(image_url)="row">
          <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(type)="row">
          <label  v-if="row.value == 'pa_service_cs_hotline'">PA Service + CS Hotline</label>
          <label  v-else-if="row.value == 'refinancing'">Refinancing</label>
          <label  v-else-if="row.value == 'insurance'">Insurance</label>
          <label  v-else-if="row.value == 'content_photo'">Content Creation - Photo</label>
          <label  v-else-if="row.value == 'content_video'">Content Creation - Video</label>
          <label  v-else-if="row.value == 'influencer'">Influencer</label>
          <label  v-else-if="row.value == 'dedicated_hero'">Dedicated HERO</label>
          <label  v-else-if="row.value == 'stockpoint'">Paxel Market + stockpoint</label>
          <label  v-else-if="row.value == 'izin_bpom'">BPOM/UKM License</label>
        </template>
        <template v-slot:cell(membership_types)="row">
          <label v-if="row.value.length > 1">All Type</label>
          <label class="text-capitalize" v-else>{{row.value[0]}}</label>
        </template>
        <template v-slot:cell(titles.id)="row">
          <label class="text-primary font-weight-bold">{{row.value}}</label>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editPointSales', params: {id: item}}"
            class="text-primary"
            style="text-decoration:none"
          >
            Edit
          </router-link>
          <!-- <b-link v-b-tooltip.hover title="Delete" class="mr-2" @click="del(row.item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>-->
          <!-- <b-link @click="row.toggleDetails">
            <label class="text-primary" style="cursor:pointer">
              Detail <img src="@/assets/ic-drop-yellow-copy-46.svg" alt />
            </label>
          </b-link> -->
          <!-- <b-button
            size="sm"
            @click="row.toggleDetails"
          >{{ row.detailsShowing ? 'Hide' : 'Show' }} Details</b-button>-->
        </template>
        <!-- <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item.reasons" :key="key">
                <ul>
                  <li>Key : {{ key }}</li>
                  <li>Value : {{ value }}</li>
                </ul>
              </li>
            </ul>
          </b-card>
        </template> -->
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      errored: false,
      member_type: "",
      items: [],
      vuex: [],
      selected: [],
      key: [
        {
          key: 'selected',
          class: 'text-center',
        },
        {
          key: 'benefit_code',
          label: 'Benefit Code',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'membership_types',
          label: 'Membership Type',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'titles.id',
          label: 'Title',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'image_url',
          label: 'Image',
          sortable: true,
          class: 'text-left',
        },
        { key: 'action', label: '', class: 'text-center' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      title: "",
      vsl_type: "",
      created_at_start: "",
      created_at_end: "",
      valid_until_start: "",
      valid_until_end: "",
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  methods: {
    search(){
      this.$refs.selectableTable.refresh();
    },
    resetDateCreatedStart(){
      this.created_at_start = "";
    },
    resetDateCreatedEnd(){
      this.created_at_end = "";
    },
    resetDateValidStart(){
      this.valid_until_start = "";
    },
    resetDateValidEnd(){
      this.valid_until_end = "";
    },
    resetSearch(){
      this.$refs.selectableTable.refresh();
      this.created_at_start = "";
      this.created_at_end = "";
      this.valid_until_start = "";
      this.valid_until_end = "";
      this.vsl_type = "";
      this.title = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("title", this.title);
      formData.append("created_at_start", this.created_at_start);
      formData.append("created_at_end", this.created_at_end);
      formData.append("valid_until_start", this.valid_until_start);
      formData.append("valid_until_end", this.valid_until_end);
      this.$store
        .dispatch("PointSalesModule/getPointOfSales", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          var dataFilter = response.data.data.filter(filter => 
          filter.type == 'pa_service_cs_hotline' || 
          filter.type == 'refinancing' || 
          filter.type == 'insurance' || 
          filter.type == 'content_photo' || 
          filter.type == 'content_video' || 
          filter.type == 'influencer' || 
          filter.type == 'dedicated_hero' || 
          filter.type == 'stockpoint' || 
          filter.type == 'izin_bpom');
          callback(dataFilter || []);
          this.loading = false;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    ReasonFilter(payload) {
      this.loading = true;
      this.$store
        .dispatch('RatingModule/getReasons', payload)
        .then((response) => {
          this.loading = false;
          this.$swal({
            type: 'success',
            title: 'Data Filtered',
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      const formData = new FormData();
      $.each(this.selected, (key, value) => {
        formData.append('reason_id', value.id);
        formData.append('status', status);
      });
      $.each(formData.getAll('reason_id'), (key, value) => {
        console.log(value);
      });
      this.loading = true;
      const payload = 'fm,lm,shipment';
      this.$store
        .dispatch('RatingModule/updateReasons', formData)
        .then((response) => {
          this.loading = false;
          this.$store.dispatch('RatingModule/getReasons', payload);
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1000,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response;
          console.log(error);
        });
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('RatingModule/delReason', id);
          this.$swal('Deleted!', 'Your file has been deleted.', 'success');
        }
      });
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style>
</style>
